import classNames from 'classnames';
import { Severity } from '../../../Data/ViewModels/Core/types';
import React from 'react';
import coalesce from '../../../Lib/coalesce';
import { withInjectedProps } from '../InjectedPropsContext';

export type ITextAreaProps = Pick<
  React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>,
  'id' | 'maxLength' | 'name' | 'disabled' | 'placeholder' | 'rows' | 'defaultValue'
> & {
  severity?: Severity;
  value?: any;
};

const TextAreaOutputBase: React.FC<ITextAreaProps> = ({
  defaultValue,
  disabled,
  id,
  maxLength,
  name,
  placeholder,
  rows,
  severity,
  value,
}) => {
  const cx = classNames('TextAreaOutput', { [`Output-${severity}`]: !!severity });

  return (
    <textarea
      className={cx}
      defaultValue={defaultValue === undefined ? defaultValue : coalesce(defaultValue, '')}
      disabled={disabled}
      id={id}
      maxLength={maxLength}
      name={name}
      readOnly={true}
      rows={rows}
      value={value === undefined ? value : coalesce(value, '')}
    />
  );
};

const TextAreaOutput = withInjectedProps(TextAreaOutputBase);

export { TextAreaOutput, TextAreaOutputBase };
export default TextAreaOutput;
